import { connect } from "react-redux";
import App from "./App";

const mapStateToProps = (state, ownProps) => {
  let status = state.prerequisites.status;
  if (status === "success") {
    status = state.currentUser.status;
  }

  return {
    status: status,
    config: state.prerequisites.config
  };
};

const AppContainer = connect(mapStateToProps)(App);

export default AppContainer;



// WEBPACK FOOTER //
// ./src/AppContainer.js